import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export default function KPICard({ label, value, hint, accent = false, testid, to }) {
  const content = (
    <div
      data-testid={testid}
      className={cn(
        "group border border-border rounded-md p-4 bg-card flex flex-col gap-1 h-full",
        accent && "border-primary/40 bg-primary/5",
        to && "cursor-pointer transition-colors duration-150 hover:border-primary/60 hover:bg-accent/40"
      )}
    >
      <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{label}</div>
      <div className="font-display text-2xl md:text-3xl font-black tracking-tight leading-none mt-1">
        {value}
      </div>
      {hint != null && (
        <div className="text-xs text-muted-foreground mt-1">{hint}</div>
      )}
    </div>
  );
  if (to) return <Link to={to} className="block h-full focus:outline-none focus:ring-2 focus:ring-primary rounded-md">{content}</Link>;
  return content;
}
